import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { ToastContainer } from '../../internal/components/ToastContainer';
import { UiKitToastsContext } from '../../internal/context';
import { useInitToastStacksApiByPlacement } from './internal/hooks';
import { UiKitToastsInternalContextProvider } from '../../internal/components/UiKitToastsInternalContextProvider';

/**
 * Провайдер контекста для компонентов уведомлений (Toast).
 *
 * Задача провайдера:
 *  - инициализация API уведомлений для каждого конкретного контейнера;
 *  - управление рендерингом контейнеров уведомлений в зависимости от параметров.
 *
 * Этот провайдер обязательно подключать ниже по иерархии компонентов, чем основной контекст "UIKitContextProvider".
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const UiKitToastsContextProvider = props => {
  const currentContext = React.useContext(UiKitToastsContext);
  const {
    children
  } = props;

  // На основе всех мест контейнеров инициализируем API для каждого контейнера
  const toastsStacksApi = useInitToastStacksApiByPlacement();
  const nextContext = React.useMemo(() => _objectSpread(_objectSpread({}, currentContext), {}, {
    toastsStacksApi
  }), [currentContext, toastsStacksApi]);
  const toastContainers = React.useMemo(() => nextContext.containersPlacements.map(placement => /*#__PURE__*/_jsx(ToastContainer, {
    placement: placement,
    stackApi: toastsStacksApi[placement]
  }, placement)), [nextContext.containersPlacements, toastsStacksApi]);
  return /*#__PURE__*/_jsx(UiKitToastsContext.Provider, {
    value: nextContext,
    children: /*#__PURE__*/_jsxs(UiKitToastsInternalContextProvider, {
      children: [toastContainers, children]
    })
  });
};